module.exports = __webpack_public_path__ + "img/main.a9894a1c.png";